var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKbDesignerIcoPositiveRemove(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Black_bez_okraje"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.49,3.51C15.8-1.17,8.2-1.17,3.51,3.51s-4.68,12.29,0,16.97,12.29,4.68,16.97,0,4.68-12.29,0-16.97ZM4.93,19.07c-3.9-3.9-3.9-10.25,0-14.14s10.25-3.9,14.14,0,3.9,10.25,0,14.14c-3.9,3.9-10.25,3.9-14.14,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.39,11.96c0-.55-.45-1-1-1H7.52c-.55,0-1,.45-1,1,0,.28.11.52.3.71s.43.29.71.3h8.87c.55,0,1-.44,1-.99h-.01Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKbDesignerIcoPositiveRemove);
export default __webpack_public_path__ + "static/media/kb-designer-ico-positive-remove.035d74e7246600fdcb559626a6d8b1f8.svg";
export { ForwardRef as ReactComponent };